import React from 'react';
import { createRoot } from 'react-dom/client';
import NotificationProvider from 'shared/providers/NotificationProvider';
import AuthProvider from 'shared/providers/AuthProvider';
import LoadingProvider from 'shared/providers/LoadingProvider';
import ConfigProvider from 'shared/providers/ConfigProvider';
import AppRouter from 'app/AppRouter';
import ThemeModeProvider from 'app/ThemeModeProvider';
import 'app/style.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ConfigProvider>
        <ThemeModeProvider>
          <LoadingProvider>
            <NotificationProvider>
              <AppRouter />
            </NotificationProvider>
          </LoadingProvider>
        </ThemeModeProvider>
      </ConfigProvider>
    </AuthProvider>
  </React.StrictMode>,
);
